import { useEffect, useState } from 'react';
import {
  getTurnstileStatus,
  isTurnstileBlocking,
  subscribeToTurnstile,
  TurnstileStatus,
} from 'src/services/turnstileService';

/** Blocks a submit button until a token exists, so a request never leaves without one. */
export const useTurnstileGate = (): boolean => {
  const [status, setStatus] = useState<TurnstileStatus>(getTurnstileStatus);

  useEffect(() => subscribeToTurnstile(setStatus), []);

  return isTurnstileBlocking(status);
};
